type NavbarFooterProps = {
  children: React.ReactElement | React.ReactElement[] | React.ReactFragment;
};

export const NavbarFooter = (props: NavbarFooterProps) => {
  const { children } = props;

  return <>{children}</>;
};
